import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_ADDITIONAL_PAYMENT: MijnRoute = {
    path: 'hypotheken-extra-storten',
    navigationEvent: 'toHypothekenExtraStorten',
    regex: /^\/hypotheek\/hypotheken-extra-storten$/,
    webcomponent: 'mijn-hypotheken-extra-storten-webcomponent'
};
